<template>
  <header class="header">
    <div class="header-links">
      <template v-if="isLive">
        <a class="header-link" href="#" @click="openStreamPlayer"
          >Watch Stream</a
        >
      </template>
      <a
        class="header-link"
        href="#"
        aria-title="Current Gear"
        title="Current Gear"
        @click="openGearList"
        >Gearlist</a
      >
      <template v-for="value in links">
        <a
          class="header-link"
          v-if="value.display"
          :key="value.id"
          :href="value.url"
          :aria-title="value.title"
          :title="value.title"
          target="_blank"
          rel="nofollow"
        >
          <span>{{ value.name }}</span>
          <span v-if="value.isLive" class="header-link-live" />
        </a>
      </template>
    </div>
  </header>
</template>

<script>
// import { setTimeout } from 'timers';
export default {
  name: 'app-header',
  computed: {
    links() {
      return [
        {
          display: true,
          name: 'Wishlist',
          title: 'Stream Wishlist',
          url: 'https://amzn.to/2E1yEDC'
        },
        {
          display: true,
          name: 'Support',
          title: 'Support hopnami',
          url: 'https://streamlabs.com/hopnami'
        }
      ];
    },
    isLive() {
      return (
        this.$store.state.mixerLiveStatus || this.$store.state.twitchLiveStatus
      );
    },
    mixerLiveStatus() {
      return this.$store.state.mixerLiveStatus;
    },
    twitchLiveStatus() {
      return this.$store.state.twitchLiveStatus;
    }
  },

  data() {
    return {
      // links: [
      //   {
      //     display: true,
      //     onClick: this.test(),
      //     name: 'Gearlist',
      //     title: 'Current Gear',
      //     url: '#'
      //   },
      //   {
      //     display: true,
      //     name: 'Wishlist',
      //     title: 'Stream Wishlist',
      //     url: 'https://amzn.to/2E1yEDC'
      //   },
      //   {
      //     display: true,
      //     name: 'Support',
      //     title: 'Support hopnami',
      //     url: 'https://streamlabs.com/hopnami'
      //   }
      // ]
    };
  },

  methods: {
    openGearList() {
      this.$root.$emit('open_modal');
      console.log('gear clicked');
    },
    openStreamPlayer() {
      this.$store.commit('toggleStreamPlayer', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  left: 0;
  padding: 15px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
}

.header-links {
  align-items: center;
  display: flex;
  margin-left: auto;
}

.header-link {
  color: rgba(#fff, 0.7);
  padding: 15px;
  position: relative;
  text-decoration: none;
  transition: color 0.3s;

  &::after,
  &::before {
    display: inline-block;
    opacity: 0;
    transition: transform 0.3s, opacity 0.2s;
  }
  &:before {
    content: '[';
    margin-right: 10px;
    transform: translateX(20px);
  }
  &:after {
    content: ']';
    margin-left: 10px;
    transform: translateX(-20px);
  }
}

.header-link-live {
  background-color: red;
  border-radius: 50%;
  bottom: 0;
  height: 6px;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  right: 0;
  width: 6px;
  z-index: 10;
}

.no-touch .header-link:hover {
  background-size: 2px 100%;
  color: #fff;
}

.no-touch .header-link:hover:after,
.no-touch .header-link:hover:before {
  opacity: 1;
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
</style>
